import { render, staticRenderFns } from "./vendors_list.vue?vue&type=template&id=27a3b469"
import script from "./vendors_list.vue?vue&type=script&lang=js"
export * from "./vendors_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports